









































































































































import { Component, Mixins, Ref } from "vue-property-decorator";
import SearchBase from "@/components/admin_common/SearchBase.vue";
import { Inquiry } from "@/model/inquiry";
import AxiosMixin from "@/mixins/axiosMixin";
import UtilMixin from "@/mixins/utilMixin";
import InquiryList from "@/components/inquiry/InquiryList.vue";
import {
  INQUIRY_STATUS,
  ANSWER_STATUS,
  ANSWER_COMPLETED,
  INQUIRY_PUBLISHED,
  INQUIRY_VERSION,
  HOPE_CONTACT_DIV,
  ANSWER_ASSIGN,
} from "@/consts/inquiry";
import SelectFilter from "#/components/selectFilter/SelectFilter.vue";
import {
  ColumnKey,
  FilterClause,
  IsFilterMatch,
} from "#/components/selectFilter/filter";
import AppAuthButton from "@/components/admin_common/AppAuthButton.vue";
import { SELECT_FILTER } from "#/const";
import { AdminUser } from "@/model/adminUser";
import FireStoreMixin from "#/mixins/firestoreMixin";
import {
  COLLECTION_INQUIRY_FILTER_OBJ,
  COLLECTION_ASSIGN_MEMBER_UPDATE,
} from "@/consts/envFireStore";
import UserMixin from "@/mixins/userMixin";
import AssignForm from "@/components/assign/AssignForm.vue";
import AssignDialog from "@/components/assign/AssignDialog.vue";
import ProgressDialog from "@/components/assign/ProgressDialog.vue";

export interface HeaderColumn {
  text: string;
  value: string;
  sortable: boolean;
  align?: string;
  width?: string;
  selected?: boolean;
  filterCondition?: number;
  filterType?: number;
  filter?: (val: object) => boolean;
  columnKey?: ColumnKey;
}

/** 表示用Inquiry */
interface DispInquiry extends Inquiry {
  ticket_no: string;
  last_answered_datetime: string;
  co_code: string;
  kst_no: string;
  corresponding_admin_names: string;
  use_receipt_type: number;
  inquiry_date: string;
  inquiry_time: string;
  hope_contact_date: string;
  hope_contact_time: string;
  all_answer_contents: string;
  answer_statuses: number;
  need_mark_hope_contact_date_time: number;
  inquiry_staff_name: string;
  inquiry_staff_furigana: string;
  co_name: string;
  office_name: string;
  normalized_inquiry_content: string;
}

interface InquiryFilterClauses {
  clauses: FilterClause[];
  sortBy: unknown[];
  sortDesc: unknown[];
}

@Component({
  components: {
    SearchBase,
    InquiryList,
    AppAuthButton,
    SelectFilter,
    AssignForm,
    AssignDialog,
    ProgressDialog,
  },
})
export default class InProgress extends Mixins(
  AxiosMixin,
  UtilMixin,
  FireStoreMixin,
  UserMixin
) {
  /** フィルター */
  @Ref("selectFilter") private readonly selectFilter!: SelectFilter;

  /** 並び項目 */
  private sortBy: unknown[] = [];

  /** 並び順 */
  private sortDesc: unknown[] = [];

  /** 一覧表示用問い合わせ情報 */
  private inquirys = [] as DispInquiry[];

  /** 管理者一覧 */
  private adminNames: string[] = [];

  /** 問い合わせタグマスタ */
  private inquiryTagNames: string[] = [];

  /** Firestore保存可能フラグ */
  private canSaveStore = false;

  /** アサインボタンクリック状態 */
  private isAssigned = false;

  /** 未アサイン化モード状態 */
  private isUnassignMode = false;

  /** アサインダイアログ表示状態 */
  private assignDialog = false;

  /** アサイン */
  private assign = {};

  /** 自分のアサイン状況 */
  private assignUser: { id: number; status: number } = { id: 0, status: 0 };

  /** 自分を受付可能状態にできるかどうか */
  private is_assignable = false;

  /** 自分が受付可能状態かどうか */
  private get AttendanceStatus(): boolean {
    return this.assignUser.id !== 0 && this.assignUser.status === 1;
  }

  /** アサイン可能メンバー表示用テキスト */
  private assign_enable_member_text = "";

  /** アサイン予定の問い合わせリスト */
  private selectedInquiries: DispInquiry[] = [];

  /** 問い合わせリスト(画面の表示順) */
  private displayedInquiries: DispInquiry[] = [];

  /** アサインスナップショットのリスナー */
  private unsubscribeAssignListener: (() => void) | null = null;

  /** アサインメンバー確定ダイアログ */
  private assignMemberDialog = false;

  /** 前回のフィルター条件 */
  private previousFilterClauses: FilterClause[] = [];

  /** アサインプレビューダイアログ */
  private assignPreviewDialog = false;

  /** 確定前apiリクエスト */
  private exec_key = "";

  /** 確定前問い合わせリスト */
  private previewInquiries: DispInquiry[] = [];

  /** アサイン対象の管理者リスト */
  private previewAdminUsers: {
    id: number;
    last_name: string;
    first_name: string;
  }[] = [];

  /** ヘッダー情報 */
  private get headers(): HeaderColumn[] {
    return [
      {
        text: "",
        value: "inquiry_tag_name",
        sortable: false,
        align: "center",
        selected: false,
        width: "100px",
        filterType: SELECT_FILTER.FILTER_TYPE.LIST,
        filter: (val: object) => this.columnFilter("inquiry_tag_name", val),
        columnKey: {
          type: SELECT_FILTER.FILTER_TYPE.LIST,
          key: "inquiry_tag_name",
          text: "問い合わせタグ",
          selectable: this.inquiryTagNames,
        },
      },
      {
        text: "詳細",
        value: "actions",
        sortable: false,
        align: "center",
        selected: false,
        width: "50px",
      },
      {
        text: "ステータス",
        sortable: false,
        value: "status",
        filterType: SELECT_FILTER.FILTER_TYPE.EQUAL_LIST,
        filter: (val: object) => this.columnFilter("status", val),
        columnKey: {
          type: SELECT_FILTER.FILTER_TYPE.EQUAL_LIST,
          key: "status",
          text: "ステータス",
          selectable: ["未対応", "進行中", "連絡とれず"],
        },
        width: "150px",
      },
      {
        text: "バージョン",
        sortable: false,
        value: "version",
        filterType: SELECT_FILTER.FILTER_TYPE.LIST,
        filter: (val: object) => this.columnFilter("version", val),
        columnKey: {
          type: SELECT_FILTER.FILTER_TYPE.LIST,
          key: "version",
          text: "バージョン",
          selectable: ["v2", "v1"],
        },
        width: "100px",
      },
      {
        text: "回答ステータス(フィルター用ダミー)",
        align: " d-none",
        sortable: false,
        value: "answer_statuses",
        filterType: SELECT_FILTER.FILTER_TYPE.LIST,
        filter: (val: object) => this.columnFilter("answer_statuses", val),
        columnKey: {
          type: SELECT_FILTER.FILTER_TYPE.LIST,
          key: "answer_statuses",
          text: "回答ステータス",
          selectable: [
            "アサイン",
            "対応中",
            "連絡待ち（外）",
            "連絡待ち（内）",
            "回答なし",
          ],
        },
      },
      {
        text: "問い合わせ公開設定(フィルター用ダミー)",
        align: " d-none",
        sortable: false,
        value: "is_published",
        filterType: SELECT_FILTER.FILTER_TYPE.LIST,
        filter: (val: object) => this.columnFilter("is_published", val),
        columnKey: {
          type: SELECT_FILTER.FILTER_TYPE.LIST,
          key: "is_published",
          text: "問い合わせ公開設定",
          selectable: ["非公開", "公開"],
        },
      },
      {
        text: "回答公開設定(フィルター用ダミー)",
        align: " d-none",
        sortable: false,
        value: "answer_is_published",
        filterType: SELECT_FILTER.FILTER_TYPE.LIST,
        filter: (val: object) => this.columnFilter("answer_is_published", val),
        columnKey: {
          type: SELECT_FILTER.FILTER_TYPE.LIST,
          key: "answer_is_published",
          text: "回答公開設定",
          selectable: ["非公開", "公開"],
        },
      },
      {
        text: "自動フラグ(フィルター用ダミー)",
        align: " d-none",
        sortable: false,
        value: "is_auto",
        filterType: SELECT_FILTER.FILTER_TYPE.LIST,
        filter: (val: object) => this.columnFilter("is_auto", val),
        columnKey: {
          type: SELECT_FILTER.FILTER_TYPE.LIST,
          key: "is_auto",
          text: "アサイン設定",
          selectable: ["手動", "自動"],
        },
      },
      {
        text: "問い合わせ内容(フィルター用ダミー)",
        align: " d-none",
        sortable: false,
        value: "normalized_inquiry_content",
        filterType: SELECT_FILTER.FILTER_TYPE.EDIT_PARTIAL,
        filter: (val: object) =>
          this.columnFilter("normalized_inquiry_content", val),
        columnKey: {
          type: SELECT_FILTER.FILTER_TYPE.EDIT_PARTIAL,
          key: "normalized_inquiry_content",
          text: "問い合わせ内容",
          selectable: [],
        },
      },
      {
        text: "希望連絡方法(チケット番号)",
        align: "center",
        sortable: false,
        value: "hope",
        width: "190px",
      },
      {
        text: "希望連絡方法(フィルター用ダミー)",
        align: " d-none",
        sortable: false,
        value: "hope_contact_div",
        filterType: SELECT_FILTER.FILTER_TYPE.LIST,
        filter: (val: object) => this.columnFilter("hope_contact_div", val),
        columnKey: {
          type: SELECT_FILTER.FILTER_TYPE.LIST,
          key: "hope_contact_div",
          text: "希望連絡方法",
          selectable: HOPE_CONTACT_DIV.map((choice) => choice.text),
        },
      },
      {
        text: "連絡希望日(フィルター用ダミー)",
        align: " d-none",
        sortable: false,
        value: "hope_contact_date",
        filterType: SELECT_FILTER.FILTER_TYPE.DATE,
        filter: (val: object) => this.columnFilter("hope_contact_date", val),
        columnKey: {
          type: SELECT_FILTER.FILTER_TYPE.DATE,
          key: "hope_contact_date",
          text: "連絡希望日",
          selectable: [],
        },
      },
      {
        text: "連絡希望時刻(フィルター用ダミー)",
        align: " d-none",
        sortable: false,
        value: "hope_contact_time",
        filterType: SELECT_FILTER.FILTER_TYPE.EDIT,
        filter: (val: object) => this.columnFilter("hope_contact_time", val),
        columnKey: {
          type: SELECT_FILTER.FILTER_TYPE.EDIT,
          key: "hope_contact_time",
          text: "連絡希望時刻",
          selectable: [],
        },
      },
      {
        text: "チケット番号(フィルター用ダミー)",
        align: " d-none",
        sortable: false,
        value: "ticket_no",
        filterType: SELECT_FILTER.FILTER_TYPE.EDIT,
        filter: (val: object) => this.columnFilter("ticket_no", val),
        columnKey: {
          type: SELECT_FILTER.FILTER_TYPE.EDIT,
          key: "ticket_no",
          text: "チケット番号",
          selectable: [],
        },
      },
      {
        text: "企業コード(フィルター用ダミー)",
        align: " d-none",
        sortable: false,
        value: "co_code",
        filterType: SELECT_FILTER.FILTER_TYPE.EDIT,
        filter: (val: object) => this.columnFilter("co_code", val),
        columnKey: {
          type: SELECT_FILTER.FILTER_TYPE.EDIT,
          key: "co_code",
          text: "企業コード",
          selectable: [],
        },
      },
      {
        text: "KST番号(フィルター用ダミー)",
        align: " d-none",
        sortable: false,
        value: "kst_no",
        filterType: SELECT_FILTER.FILTER_TYPE.EDIT,
        filter: (val: object) => this.columnFilter("kst_no", val),
        columnKey: {
          type: SELECT_FILTER.FILTER_TYPE.EDIT,
          key: "kst_no",
          text: "KST番号",
          selectable: [],
        },
      },
      {
        text: "回答内容(フィルター用ダミー)",
        align: " d-none",
        sortable: false,
        value: "all_answer_contents",
        filterType: SELECT_FILTER.FILTER_TYPE.EDIT_PARTIAL,
        filter: (val: object) => this.columnFilter("all_answer_contents", val),
        columnKey: {
          type: SELECT_FILTER.FILTER_TYPE.EDIT_PARTIAL,
          key: "all_answer_contents",
          text: "回答内容",
          selectable: [],
        },
      },
      {
        text: "事業所名",
        align: "start",
        sortable: true,
        value: "office_name",
        filterType: SELECT_FILTER.FILTER_TYPE.EDIT,
        filter: (val: object) => this.columnFilter("office_name", val),
        columnKey: {
          type: SELECT_FILTER.FILTER_TYPE.EDIT,
          key: "office_name",
          text: "事業所名",
          selectable: [],
        },
        width: "180px",
      },
      {
        text: "対応者",
        align: "start",
        sortable: false,
        value: "corresponding_admin_names",
        filterType: SELECT_FILTER.FILTER_TYPE.EDIT,
        filter: (val: object) =>
          this.columnFilter("corresponding_admin_names", val),
        columnKey: {
          type: SELECT_FILTER.FILTER_TYPE.EDIT,
          key: "corresponding_admin_names",
          text: "対応者",
          selectable: [],
        },
        width: "150px",
      },
      {
        text: "問い合わせ日",
        align: "start",
        sortable: true,
        value: "inquiry_date",
        width: "150px",
        filterType: SELECT_FILTER.FILTER_TYPE.DATE,
        filter: (val: object) => this.columnFilter("inquiry_date", val),
        columnKey: {
          type: SELECT_FILTER.FILTER_TYPE.DATE,
          key: "inquiry_date",
          text: "問合せ日",
          selectable: [],
        },
      },
      {
        text: "問い合わせ時刻",
        align: "start",
        sortable: true,
        value: "inquiry_time",
        width: "150px",
        filterType: SELECT_FILTER.FILTER_TYPE.EDIT,
        filter: (val: object) => this.columnFilter("inquiry_time", val),
        columnKey: {
          type: SELECT_FILTER.FILTER_TYPE.EDIT,
          key: "inquiry_time",
          text: "問合せ時刻",
          selectable: [],
        },
      },
      {
        text: "希望連絡日時",
        align: "start",
        sortable: true,
        value: "hope_contact_datetime",
        width: "150px",
      },
      {
        text: "最終回答日時",
        align: "start",
        sortable: true,
        value: "last_answered_datetime",
        width: "150px",
        filterType: SELECT_FILTER.FILTER_TYPE.DATE,
        filter: (val: object) =>
          this.columnFilter("last_answered_datetime", val),
        columnKey: {
          type: SELECT_FILTER.FILTER_TYPE.DATE,
          key: "last_answered_datetime",
          text: "最終回答日時",
          selectable: [],
        },
      },
      {
        text: "企業名",
        align: "start",
        sortable: true,
        value: "co_name",
        filterType: SELECT_FILTER.FILTER_TYPE.EDIT,
        filter: (val: object) => this.columnFilter("co_name", val),
        columnKey: {
          type: SELECT_FILTER.FILTER_TYPE.EDIT,
          key: "co_name",
          text: "企業名",
          selectable: [],
        },
        width: "150px",
      },
    ];
  }

  async created() {
    this.collection = COLLECTION_INQUIRY_FILTER_OBJ;
    this.documentId = String(this.User.id);
    const data = await this.documentGet();
    if (data) {
      const clauses = data as InquiryFilterClauses;
      this.selectFilter.clearAll();
      clauses.clauses.forEach((data) => {
        this.selectFilter.filterClauses.push(data);
      });
      this.sortBy = clauses.sortBy;
      this.sortDesc = clauses.sortDesc;
    }
    this.canSaveStore = true;

    // アサイン
    this.unsubscribeAssignListener = this.getFirestoreDB()
      .collection(COLLECTION_ASSIGN_MEMBER_UPDATE)
      .doc("1")
      .onSnapshot(() => {
        this.fetchAssign();
      });
  }

  beforeDestroy() {
    // スナップショットのリスナー解除
    if (this.unsubscribeAssignListener) {
      this.unsubscribeAssignListener();
      this.unsubscribeAssignListener = null;
    }
  }

  // APIを呼んで完了状態以外の問い合わせ情報を全取得
  private async fetchInquiries() {
    this.postJsonCheck(
      window.base_url + "/api/admin/inquiries/inprogress/get",
      {},
      (res) => {
        this.inquirys = res.data.inquirys;
        this.adminNames = res.data.admin_users.map((adminUser: AdminUser) => {
          return `${adminUser.last_name} ${adminUser.first_name}`;
        });
        this.inquiryTagNames = res.data.inquiry_tag_names;
      }
    );
  }

  private async fetchAssign() {
    this.postJsonNoloading(
      window.base_url + "/api/admin/assign/get",
      {},
      (res) => {
        // アサイン中メンバー情報取得
        this.assign_enable_member_text = res.data.assign_enable_member_text;
      }
    );
    this.postJsonNoloading(
      window.base_url + "/api/admin/assign_admin_user/get",
      {},
      (res) => {
        // 自分のアサイン情報取得
        this.assignUser = res.data.assign_admin_user;
        this.assign = res.data.assign;
        this.is_assignable = res.data.is_assignable;
      }
    );
  }

  /** 問い合わせ詳細画面へ遷移（別タブ） */
  private gotoEditPage(id: number) {
    window.open("/inquiry/show/" + id, "_blank");
  }

  /**
   * SelectFilterの選択肢
   * @return ColumnKey
   */
  private get columnKeys(): ColumnKey[] {
    const keys = this.headers
      .filter((headerColumn: HeaderColumn) => headerColumn.filter != null)
      .map((headerColumn: HeaderColumn) => headerColumn.columnKey);

    if (keys.length == 0) {
      return [] as ColumnKey[];
    }

    return keys as ColumnKey[];
  }

  /** カラムフィルター */
  private columnFilter(key: string, val: unknown) {
    switch (key) {
      case "status":
        val = this.idToText(val as number, INQUIRY_STATUS);
        break;
      case "version":
        val = this.idToText(val as number, INQUIRY_VERSION);
        break;
      case "answer_statuses":
        // 回答がない場合
        if ((val as []).length === 0) {
          val = ["回答なし"];
          break;
        }
        val = (val as []).flatMap((status: number) => {
          return status < ANSWER_COMPLETED || status === ANSWER_ASSIGN
            ? this.idToText(status, ANSWER_STATUS)
            : [];
        });
        val = (val as []).join(" ");
        break;
      case "answer_is_published":
      case "is_published":
        val = this.idToText(val as number, INQUIRY_PUBLISHED);
        break;
      case "hope_contact_div":
        val = this.idToText(val as number, HOPE_CONTACT_DIV);
        break;
      case "is_auto":
        val = (val as number) === 1 ? "自動" : "手動";
        break;
      default:
        break;
    }
    const bret = IsFilterMatch(
      this.selectFilter.filterClauses,
      key,
      val as string | number
    );
    return bret;
  }

  //並び順序変更
  private updateSortBy(value: []) {
    this.sortBy = value;
    this.onChangeCondition();
  }

  //並び項目変更
  private updateSortDesc(value: []) {
    this.sortDesc = value;
    this.onChangeCondition();
  }

  /**
   * フィルター条件の変更確定時
   * 単体削除、全体削除、入力後のブラー
   */
  private onChangeCondition() {
    if (this.canSaveStore) {
      const clauses: InquiryFilterClauses = {
        clauses: this.selectFilter.filterClauses,
        sortBy: this.sortBy,
        sortDesc: this.sortDesc,
      };
      this.documentSave(clauses);
    }
  }

  private async selectAssignMember() {
    if (!this.selectedInquiries || this.selectedInquiries.length === 0) {
      this.$openAlert("1つ以上の問い合わせを選んでください。");
      return;
    }

    if (
      !(await this.$openConfirm(
        "次に、選択中の問い合わせについて、今回割り当てるメンバーを選択します。よろしいですか？"
      ))
    ) {
      return;
    }

    this.assignMemberDialog = true;
  }

  private async saveAssignInquiry(selectAssignMembers: AdminUser[]) {
    if (!selectAssignMembers || selectAssignMembers.length === 0) {
      this.$openAlert("1人以上のメンバーを選んでください。");
      return;
    }

    if (
      !(await this.$openConfirm(
        "選択中の問い合わせについて、選択したメンバーにアサインします。よろしいですか？"
      ))
    ) {
      return;
    }

    // 画面の順番になるように、displayedInquiriesを使う
    const inquiries = this.displayedInquiries.filter((dispInquiry) =>
      this.selectedInquiries.some(
        (selectedInquiry) => selectedInquiry.id === dispInquiry.id
      )
    );

    this.previewAdminUsers = selectAssignMembers.map((u) => ({
      id: u.id,
      last_name: u.last_name,
      first_name: u.first_name,
    }));

    this.postJsonCheck(
      window.base_url + "/api/admin/assign/inquiries",
      {
        inquiries: inquiries,
        admin_users: selectAssignMembers,
      },
      async (res) => {
        this.exec_key = res.data.exec_key;
        this.previewInquiries = res.data.inquiries;
        this.assignPreviewDialog = true;
      }
    );
  }

  /** アサイン確定処理 */
  private async commitAssignInquiry(
    overrides: {
      inquiry_id: number;
      admin_user_id: number;
      admin_user_name: string;
    }[]
  ) {
    if (!(await this.$openConfirm("確定します。よろしいですか？"))) {
      return;
    }

    this.postJsonCheck(
      window.base_url + "/api/admin/assign/inquiries/commit",
      {
        exec_key: this.exec_key,
        overrides: overrides ?? [],
      },
      async (res) => {
        let msg = "アサインしました。";
        const conflicts: { ticket_no: string; admin_user_name: string }[] =
          res.data.conflicts ?? [];
        if (conflicts.length > 0) {
          const details = conflicts
            .map(
              (c) =>
                `チケット番号${c.ticket_no}は、すでに${c.admin_user_name}さんに個別でアサインされていたため、スキップしました。`
            )
            .join("\n");
          msg += `\n\n${details}`;
        }
        await this.$openAlert(msg);
        this.fetchInquiries();
        this.selectedInquiries = [];
        this.assignMemberDialog = false;
        this.assignPreviewDialog = false;
        this.stopAssignMode();
      }
    );
  }

  private saveAssignUser() {
    this.assignUser.status = 1;
    this.postJsonCheck(
      window.base_url + "/api/admin/assign_admin_user/save",
      {
        assign_admin_user: this.assignUser,
        assign: this.assign,
      },
      () => {
        // this.$openAlert("受付中にしました。");
      }
    );
  }

  private deleteAssignUser() {
    this.assignUser.status = 0;
    this.postJsonCheck(
      window.base_url + "/api/admin/assign_admin_user/save",
      {
        assign_admin_user: this.assignUser,
        assign: this.assign,
      },
      () => {
        // this.$openAlert("離席中にしました。");
      }
    );
  }

  /** アサインモード開始 */
  private startAssignMode() {
    this.isAssigned = true;

    this.previousFilterClauses = [...this.selectFilter.filterClauses];

    // 既存のフィルターを削除（競合を避けるため、対象カラムのフィルターはいったんクリア）
    this.selectFilter.filterClauses = [];

    // // 問い合わせ公開設定: 公開
    // const headerPublished = this.headers.find(
    //   (h) => h.columnKey && h.columnKey.key === "is_published"
    // );
    // if (headerPublished && headerPublished.columnKey) {
    //   this.selectFilter.filterClauses.push({
    //     id: new Date().getTime(),
    //     word: "公開",
    //     menu: false,
    //     matchType: SELECT_FILTER.MATCH_TYPE_PREFIX,
    //     numIdx: 0,
    //     dateFilterCondition: 0,
    //     colKey: headerPublished.columnKey,
    //   });
    // }

    // ステータス: 未対応
    const headerStatus = this.headers.find(
      (h) => h.columnKey && h.columnKey.key === "status"
    );
    if (headerStatus && headerStatus.columnKey) {
      this.selectFilter.filterClauses.push({
        id: new Date().getTime() + 1,
        word: "未対応",
        menu: false,
        matchType: SELECT_FILTER.MATCH_TYPE_PERFECT,
        numIdx: 0,
        dateFilterCondition: 0,
        colKey: headerStatus.columnKey,
      });
    }

    // 回答ステータス: 回答なし
    const headerAnswerStatus = this.headers.find(
      (h) => h.columnKey && h.columnKey.key === "answer_statuses"
    );
    if (headerAnswerStatus && headerAnswerStatus.columnKey) {
      this.selectFilter.filterClauses.push({
        id: new Date().getTime() + 1,
        word: "回答なし",
        menu: false,
        matchType: SELECT_FILTER.MATCH_TYPE_PERFECT,
        numIdx: 0,
        dateFilterCondition: 0,
        colKey: headerAnswerStatus.columnKey,
      });
    }

    // Firestoreに保存しない
    // this.onChangeCondition();
  }

  private stopAssignMode() {
    this.isAssigned = false;

    // 前回のフィルター条件を復元
    this.selectFilter.filterClauses = [...this.previousFilterClauses];
    this.previousFilterClauses = [];

    this.onChangeCondition();
  }

  /** 未アサイン化モード開始 */
  private startUnassignMode() {
    this.isUnassignMode = true;
    this.previousFilterClauses = [...this.selectFilter.filterClauses];
    this.selectFilter.filterClauses = [];

    // ステータス: 未対応
    const headerStatus = this.headers.find(
      (h) => h.columnKey && h.columnKey.key === "status"
    );
    if (headerStatus && headerStatus.columnKey) {
      this.selectFilter.filterClauses.push({
        id: new Date().getTime(),
        word: "未対応",
        menu: false,
        matchType: SELECT_FILTER.MATCH_TYPE_PERFECT,
        numIdx: 0,
        dateFilterCondition: 0,
        colKey: headerStatus.columnKey,
      });
    }

    // 回答ステータス: アサイン済みのみ表示
    const headerAnswerStatus = this.headers.find(
      (h) => h.columnKey && h.columnKey.key === "answer_statuses"
    );
    if (headerAnswerStatus && headerAnswerStatus.columnKey) {
      this.selectFilter.filterClauses.push({
        id: new Date().getTime() + 1,
        word: "アサイン",
        menu: false,
        matchType: SELECT_FILTER.MATCH_TYPE_PERFECT,
        numIdx: 0,
        dateFilterCondition: 0,
        colKey: headerAnswerStatus.columnKey,
      });
    }
  }

  /** 未アサイン化モード終了 */
  private stopUnassignMode() {
    this.isUnassignMode = false;
    this.selectFilter.filterClauses = [...this.previousFilterClauses];
    this.previousFilterClauses = [];
    this.onChangeCondition();
  }

  /** 未アサイン化実行 */
  private async executeUnassign() {
    if (!this.selectedInquiries || this.selectedInquiries.length === 0) {
      this.$openAlert("1つ以上の問い合わせを選んでください。");
      return;
    }

    if (
      !(await this.$openConfirm(
        "選択した問い合わせのアサインを解除します。よろしいですか？"
      ))
    ) {
      return;
    }

    this.postJsonCheck(
      window.base_url + "/api/admin/assign/inquiries/unassign",
      {
        inquiry_ids: this.selectedInquiries.map((i) => i.id),
      },
      async () => {
        await this.$openAlert("アサインを解除しました。");
        this.fetchInquiries();
        this.selectedInquiries = [];
        this.stopUnassignMode();
      }
    );
  }
}
